/* eslint-disable react/prop-types */
import { useState } from 'react';
import { IoMdClose } from 'react-icons/io';

import Card from '../../../components/Card';

interface KOLEbookIdsValue {
  ebookIds: string[];
}

interface KOLEbookIdsPresenterProps {
  value?: KOLEbookIdsValue;
  onChange?: (value: KOLEbookIdsValue) => void;
}

export const KOLEbookIdsPresenter: React.FC<KOLEbookIdsPresenterProps> = ({ value, onChange }) => {
  const [tempValue, setTempValue] = useState<string>('');
  const ebookIds = value?.ebookIds || [];

  const handleAddEbookId = () => {
    if (!tempValue.trim() || ebookIds.includes(tempValue.trim())) return;

    const newEbookIds = [...ebookIds, tempValue.trim()];
    onChange?.({ ebookIds: newEbookIds });
    setTempValue('');
  };

  const handleRemoveEbookId = (index: number) => {
    const newEbookIds = ebookIds.filter((_, i) => i !== index);
    onChange?.({ ebookIds: newEbookIds });
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddEbookId();
    }
  };

  const handleCommaInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setTempValue(inputValue);

    // Check if input contains comma
    if (inputValue.includes(',')) {
      const parts = inputValue
        .split(',')
        .map((part) => part.trim())
        .filter((part) => part.length > 0);
      if (parts.length > 1) {
        const newEbookIds = [...ebookIds];
        parts.forEach((part) => {
          if (part && !ebookIds.includes(part)) {
            newEbookIds.push(part);
          }
        });
        onChange?.({ ebookIds: newEbookIds });
        setTempValue('');
      }
    }
  };

  return (
    <Card className="flex flex-col space-y-8">
      <div className="text-22">Ebook IDs</div>
      <div className="form-control">
        <label className="label">
          <span className="label-text text-systemGrays02LabelSecondary">
            Ebook IDs <span className="text-colorsBrandRed01Primary">*</span>
          </span>
        </label>
        <div className="flex flex-wrap items-center gap-2 p-3 border border-systemGrays02LabelSecondary rounded-lg bg-componentsBgGrouped02">
          {ebookIds.map((ebookId, index) => (
            <button
              key={index}
              type="button"
              onClick={() => handleRemoveEbookId(index)}
              className="h-8 px-3 py-1 bg-colorsBrandRed01Primary text-white border border-colorsBrandRed01Primary rounded-full flex items-center gap-2 hover:bg-red-600 transition-colors"
            >
              <span className="text-sm font-tt">{ebookId}</span>
              <IoMdClose className="w-4 h-4" />
            </button>
          ))}

          <input
            type="text"
            className="flex-1 min-w-0 outline-none bg-transparent text-sm font-tt text-systemGrays02LabelSecondary font-semibold"
            value={tempValue}
            onChange={handleCommaInput}
            onKeyDown={handleKeyDown}
            placeholder="Enter ebook IDs separated by commas or press Enter"
          />
        </div>
        <label className="label">
          <span className="label-text-alt text-systemGrays02LabelSecondary font-tt">Enter ebook IDs separated by commas or press Enter to add each ID</span>
        </label>
      </div>
    </Card>
  );
};
